// extracted by mini-css-extract-plugin
export default {"lastModifiedDateTime":"Employee_lastModifiedDateTime__lFec3"};